export const authConstants = {
    LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
    LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
    LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',
    SHOW_2FA_SETUP: 'SHOW_2FA_SETUP',
    SHOW_OTP_CHALLENGE: 'SHOW_OTP_CHALLENGE',
    REFRESH: 'REFRESH',

    LOGOUT: 'USERS_LOGOUT'
};